module.exports = __webpack_public_path__ + "static/media/Learning-Platform-Partner-logo.c15ead86.png";